@if (orgSupplementaryData) {
    <dx-check-box [value]="useCustomWelcomeEmail"
                  (valueChange)="onCustomMessageChecked($any($event))"
                  text="Use custom welcome email"></dx-check-box>
    @if (useCustomWelcomeEmail) {
        <div>
            <h3 class="my-3">Welcome email message</h3>
            <adapt-html-editor [(contents)]="orgSupplementaryData.customWelcomeEmail"
                               (isValidChange)="isEditorValid = $event"></adapt-html-editor>
            <div class="mt-3 alert alert-light">
                <b>{{"{{ONAME}}"}}</b> is the name of your organisation.
                <br />
                <b>{{"{{SNAME}}"}}</b> is the sender name of the welcome email.
            </div>
        </div>
        }
        <div class="mt-2">
            <button adaptButtonIcon="view"
                    [disabled]="!isEditorValid"
                    [adaptBlockingClick]="previewEmail">Preview welcome email</button>
        </div>
        }
